import { useCallback, useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { Button, Tag } from "antd";
import CreateOfferModal from "./create-offer";
import api from "../../services/api";
import toast from "react-hot-toast";
import AdminGrid from "../../components/adminGrid/adminGrid";
import dayjs from "dayjs";

const SubscriptionOffers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [allSubscriptions, setAllSubscriptions] = useState([]);
  const [activeOffers, setActiveOffers] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchLimitedTimeOffers();
    fetchSubcsriptionPackages();
    // eslint-disable-next-line
  }, []);

  const fetchSubcsriptionPackages = useCallback(async () => {
    try {
      const { data } = await api.get("/subscriptions");
      const filtered = data?.data?.filter((x) => x?.price !== 0);
      setAllSubscriptions(filtered);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  }, []);

  const fetchLimitedTimeOffers = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get(
        "limitedTimeOffers?type=DISCOUNT&active=true"
      );
      console.log("data", data?.data);
      setActiveOffers(data?.data);
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };

  const getRowHeight = (params) => {
    var Heights = [55, 55, 55, 55];
    return Heights[params.node.rowIndex % 4];
  };

  const gridOptions = {
    getRowHeight: getRowHeight,
  };

  const centerStyle = {
    display: "flex",
    alignItems: "center",
    fontSize: "14px",
  };

  const columns = [
    {
      headerName: "Start Date",
      field: "startDate",
      flex: 0.3,
      cellRenderer: (params) => dayjs(params.value).format("D MMMM YYYY"),
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "End Date",
      field: "endDate",
      flex: 0.3,
      cellRenderer: (params) => dayjs(params.value).format("D MMMM YYYY"),
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Discount (%)",
      field: "discountPercentage",
      flex: 0.3,
      valueGetter: (params) =>
        params.data?.metadata?.[0]?.discountPercentage ?? "-",
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Subscription",
      field: "subscriptionName",
      flex: 0.4,
      valueGetter: () => "Annual Pro",
      cellStyle: centerStyle,
      filter: true,
    },
    {
      headerName: "Status",
      field: "isActive",
      flex: 0.3,
      cellRenderer: (params) =>
        params.value ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
      cellStyle: centerStyle,
      filter: true,
    },
  ];

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="h3 m-0">Subscription offers</h3>
        <Button
          size="large"
          className="btn_contained fs_12 px-2 text-white"
          onClick={() => setIsModalOpen(true)}
        >
          Create
        </Button>
      </div>

      <div className="d-flex justify-content-between">
        <div className="fs_14 pt-1 col-md-12 col-lg-12 col-12">
          {isLoading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ height: "100vh" }}
            >
              <div>Loading...</div>
            </div>
          ) : (
            <AdminGrid
              row={activeOffers}
              cols={columns}
              rowClass={"fs_12"}
              gridOptions={gridOptions}
              style={{ height: "100%" }}
              pagination={true}
            />
          )}
        </div>
      </div>

      {isModalOpen && (
        <CreateOfferModal
          isOpen={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          subscriptions={allSubscriptions}
        />
      )}
    </Layout>
  );
};

export default SubscriptionOffers;
